import {
  classifyAttendanceMonth,
  formatReportingMonth,
  isReportingPeriodIncomplete,
  overviewAttendanceCoveragePercent,
  reportingMonthKey,
  selectReportingMonthRow,
} from "../../services/reportingPeriod.js";

/**
 * Display-only attendance metadata shared by the office Overview cards.
 * Space fit deliberately keeps its own numeric row selection.
 * Resolver completeness describes the target month, never a lagged row.
 */
export function officeAttendanceCaption(location, currentDate = new Date()) {
  const period = location?.reportingPeriod;
  const row = selectReportingMonthRow(location?.utilization, period);
  const targetKey = reportingMonthKey(period?.month);
  const dataKey = reportingMonthKey(row?.month);
  const targetMonth = formatReportingMonth(period?.month);
  const dataMonth = formatReportingMonth(row?.month);

  if (!dataMonth || row?.peakDailyUniqueBadges == null) {
    return targetMonth ? `${targetMonth} pending` : null;
  }
  if (targetKey && dataKey < targetKey) {
    return `${dataMonth} · ${targetMonth} pending`;
  }
  if (targetKey !== dataKey) return dataMonth;
  const state = classifyAttendanceMonth(period?.month, currentDate);
  if (state === "elapsed") {
    const percent = overviewAttendanceCoveragePercent(period);
    return `${dataMonth} (final${percent != null ? ` — ${percent}% coverage` : ""})`;
  }
  if (state === "future") return `${dataMonth} (upcoming)`;
  const finalizing = state === "current" && isReportingPeriodIncomplete(period);
  return `${dataMonth}${finalizing ? " (finalizing)" : ""}`;
}
